import { CdkCopyToClipboard, Clipboard } from '@angular/cdk/clipboard';
import { Directive, HostListener, inject, Input, } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from "@ngx-translate/core";

@Directive({
  selector: '[appCopyToClipboardCopied]',
  standalone: true,
  providers: [CdkCopyToClipboard],
})
export class CopyToClipboardCopiedDirective {
  @Input('appCopyToClipboardCopied') value!: string;
  private clipboard: Clipboard = inject(Clipboard);
  private matSnackBar: MatSnackBar = inject(MatSnackBar);
  private translateService: TranslateService = inject(TranslateService);

  @HostListener('click') handlerClick(): void {
    const result = this.clipboard.copy(this.value);
    if (result) {
      const snackConfig: MatSnackBarConfig = {
        duration: 2000,
      }
      this.matSnackBar.open(this.translateService.instant('common.message.copied'), this.translateService.instant('common.buttons.close'), snackConfig)
    }
  }
}
